import {
	Page,
	Text,
	Document,
	StyleSheet,
	View,
	Image,
} from "@react-pdf/renderer";
import logoFermat from "../../assets/fermat_logo_3.png";
import { getStatusCarga, valorMoeda } from "../../services/Servicos";
import { returnDataWithCorrection } from "../../services/helpers";

const styles = StyleSheet.create({
	body: {
		paddingTop: 10,
		paddingBottom: 50,
		paddingHorizontal: 30,
		fontSize: 10,
	},
	header: {
		fontSize: 8,
		color: "#6c757d",
		width: "100%",
		textAlign: "right",
	},
	pageNumber: {
		fontSize: 10,
		textAlign: "center",
		color: "grey",
		marginBottom: 5,
	},
	headerFixed: {
		display: "flex",
		flexDirection: "row",
		margin: 12,
		justifyContent: "space-between",
		alignItems: "center",
		borderBottom: 2,
		borderColor: "#0d6efd",
		paddingBottom: 15,
		backgroundColor: "white",
		borderRadius: 8,
		padding: 15,
	},
	footerFixed: {
		position: "absolute",
		bottom: 0,
		margin: 12,
		left: 12,
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		color: "#6c757d",
		fontSize: 8,
	},
	infoBadge: {
		backgroundColor: "#e7f1ff",
		padding: 5,
		borderRadius: 4,
		marginBottom: 3,
		borderLeft: 3,
		borderLeftColor: "#0d6efd",
	},
	bodyText: {
		padding: 8,
		marginBottom: 3,
		backgroundColor: "white",
		borderRadius: 4,
		fontSize: 9,
		borderLeft: 3,
		borderLeftColor: "#0d6efd",
	},
	bodyTextOverline: {
		verticalAlign: "super",
		fontSize: "5px",
	},
	sectionTitle: {
		textAlign: "left",
		fontSize: 14,
		color: "#212529",
		marginHorizontal: 12,
		marginTop: 15,
		marginBottom: 10,
		padding: 8,
		fontWeight: "bold",
		borderBottom: 0.5,
		borderBottomColor: "#212529",
	},
	sectionSubtitle: {
		fontSize: 11,
		color: "#495057",
		marginHorizontal: 12,
		marginBottom: 8,
		fontWeight: "bold",
	},
	thead: {
		marginHorizontal: 12,
		width: "100%",
		color: "white",
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-start",
		alignItems: "center",
		backgroundColor: "#212529",
		borderTopLeftRadius: 6,
		borderTopRightRadius: 6,
		paddingVertical: 8,
	},
	td: {
		fontSize: 8,
		paddingHorizontal: 5,
		paddingVertical: 3,
		marginBottom: 0,
		textAlign: "left",
		backgroundColor: "transparent",
	},
	tableRow: {
		display: "flex",
		flexDirection: "row",
		borderBottom: 1,
		borderColor: "#dee2e6",
		marginHorizontal: 12,
		backgroundColor: "white",
	},
	tableRowAlt: {
		backgroundColor: "#f8f9fa",
	},
	cardContainer: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: "flex-start",
		width: "95%",
		marginHorizontal: 12,
		marginBottom: 15,
		gap: 10,
	},
	card: {
		padding: 12,
		borderRadius: 8,
		height: 65,
		width: 110,
		marginBottom: 5,
		backgroundColor: "#e7f1ff",
	},
	cardLabel: {
		fontSize: 8,
		marginBottom: 6,
		color: "#6c757d",
		fontWeight: "bold",
		textTransform: "uppercase",
	},
	cardValue: {
		fontSize: 15,
		fontWeight: "bold",
		color: "#212529",
	},
	infoRow: {
		display: "flex",
		flexDirection: "row",
		marginBottom: 6,
		paddingVertical: 4,
		paddingHorizontal: 8,
		backgroundColor: "white",
		borderRadius: 4,
	},
	infoLabel: {
		fontSize: 8,
		fontWeight: "bold",
		color: "#495057",
		width: "40%",
	},
	infoValue: {
		fontSize: 8,
		color: "#212529",
		width: "60%",
	},
	summaryCard: {
		backgroundColor: "#0d6efd",
		padding: 12,
		borderRadius: 8,
		marginHorizontal: 12,
		marginBottom: 10,
	},
	summaryText: {
		color: "white",
		fontSize: 10,
		marginBottom: 3,
	},
	summaryValue: {
		color: "white",
		fontSize: 16,
		fontWeight: "bold",
	},
});

const formatNumber = (number) => Number(number || 0).toLocaleString("pt-BR");



export default function PDFRelatorioFinalCarga({ carga, pedidos, produtos }) {
	
	const formatDate = (date) => {
		if (!date) return "N/A";
		return returnDataWithCorrection(date).toLocaleDateString("pt-BR");
	};

	const valorTotalPedidos = pedidos.reduce(
		(total, pedido) => total + (Number(pedido.valor_total) || 0),
		0
	);

	const pesoTotalPedidos = pedidos.reduce(
		(total, pedido) => total + (Number(pedido.peso_nf) || 0),
		0
	);

	return (
		<Document
			title={`Relatório Final - Carga ${carga.id} - ${carga.nome}`}
		>
			{/* FOLHA DE ROSTO */}
			<Page style={styles.body}>
				<View style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					padding: 40,
				}}>
					{/* Logo */}
					<View style={{ marginBottom: 40, width: "60%" }}>
						<Image src={logoFermat} />
					</View>

					{/* Título Principal */}
					<Text style={{
						fontSize: 28,
						fontWeight: "bold",
						color: "#212529",
						marginBottom: 10,
						textAlign: "center",
					}}>
						RELATÓRIO FINAL DE CARGA
					</Text>

					{/* Informação da Carga */}
					<View style={{
						backgroundColor: "#e7f1ff",
						padding: 20,
						borderRadius: 8,
						marginTop: 20,
						width: "80%",
					}}>
						<Text style={{
							fontSize: 16,
							color: "#495057",
							marginBottom: 8,
							textAlign: "center",
						}}>
							Carga Nº {carga.id}
						</Text>
						<View style={{
							borderTop: 1,
							borderColor: "#dee2e6",
							paddingTop: 15,
							marginTop: 10,
						}}>
							<View style={{ marginBottom: 8 }}>
								<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
									Status
								</Text>
								<Text style={{ fontSize: 12, fontWeight: "bold", color: "#212529" }}>
									{getStatusCarga(carga.status)}
								</Text>
							</View>
							<View style={{ marginBottom: 8 }}>
								<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
									Responsável
								</Text>
								<Text style={{ fontSize: 12, fontWeight: "bold", color: "#212529" }}>
									{carga.responsavel || "N/A"}
								</Text>
							</View>
						</View>
					</View>

					{/* Informações do Motorista */}
					<View style={{
						backgroundColor: "#fff",
						padding: 20,
						borderRadius: 8,
						marginTop: 20,
						width: "80%",
						border: 1,
						borderColor: "#dee2e6",
					}}>
						<Text style={{
							fontSize: 14,
							fontWeight: "bold",
							color: "#495057",
							marginBottom: 15,
							textAlign: "center",
						}}>
							👤 MOTORISTA
						</Text>
						<View style={{ marginBottom: 8 }}>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								Nome
							</Text>
							<Text style={{ fontSize: 12, color: "#212529" }}>
								{carga.motorista_nome || "N/A"}
							</Text>
						</View>
						<View style={{ marginBottom: 8 }}>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								CPF
							</Text>
							<Text style={{ fontSize: 12, color: "#212529" }}>
								{carga.motorista_cpf || "N/A"}
							</Text>
						</View>
						<View style={{ marginBottom: 8 }}>
							<Text style={{ fontSize: 10, color: "#6c757d", marginBottom: 3 }}>
								Telefone
							</Text>
							<Text style={{ fontSize: 12, color: "#212529" }}>
								{carga.motorista_telefone || "N/A"}
							</Text>
						</View>

						{/* Dados Bancários */}
						{carga.dadosBancarios && (
							<View style={{
								marginTop: 15,
								paddingTop: 15,
								borderTop: 1,
								borderColor: "#dee2e6",
							}}>
								<Text style={{
									fontSize: 12,
									fontWeight: "bold",
									color: "#495057",
									marginBottom: 10,
								}}>
									💳 Dados Bancários
								</Text>
								{carga.dadosBancarios.chave_pix && carga.dadosBancarios.chave_pix.trim() !== "" ? (
									// Se tem chave PIX, mostrar apenas dados PIX
									<>
										<View style={{ marginBottom: 6 }}>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Tipo de Chave PIX
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.tipo_pix || "N/A"}
											</Text>
										</View>
										<View>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Chave PIX
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.chave_pix}
											</Text>
										</View>
									</>
								) : (
									// Senão, mostrar dados bancários completos
									<>
										<View style={{ marginBottom: 6 }}>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Banco
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.banco || "N/A"}
											</Text>
										</View>
										<View style={{ marginBottom: 6 }}>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Agência
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.agencia || "N/A"}
											</Text>
										</View>
										<View style={{ marginBottom: 6 }}>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Conta
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.conta || "N/A"}
											</Text>
										</View>
										<View>
											<Text style={{ fontSize: 9, color: "#6c757d", marginBottom: 2 }}>
												Tipo de Conta
											</Text>
											<Text style={{ fontSize: 10, color: "#212529" }}>
												{carga.dadosBancarios.tipo_conta || "N/A"}
											</Text>
										</View>
									</>
								)}
							</View>
						)}
					</View>

					{/* Rodapé */}
					<View style={{
						position: "absolute",
						bottom: 30,
						left: 0,
						right: 0,
						textAlign: "center",
					}}>
						<Text style={{ fontSize: 8, color: "#adb5bd" }}>
							Sistema B-LOG • Gerado em {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR")}
						</Text>
					</View>
				</View>
			</Page>

			{/* PÁGINAS DE CONTEÚDO */}
			<Page style={styles.body}>
				{/* Header */}
				<View style={styles.headerFixed}>
					<View style={{ width: "50%" }}>
						<Image style={{ img: "100%" }} src={logoFermat}></Image>
					</View>
					<View style={styles.header}>
						<Text style={{ marginBottom: 5 }}>
							Carga {carga.id} - {carga.nome}
						</Text>
						<Text style={{ marginBottom: 5 }}>Sistema B-LOG</Text>
						<Text style={{ marginBottom: 5 }}>
							Fermat Indústria e Comércio e Perfis LTDA
						</Text>
					</View>
				</View>

			{/* Dados da Carga */}
			<Text style={styles.sectionTitle}>🚛 INFORMAÇÕES DA CARGA</Text>
				<View
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						width: "100%",
					}}
				>
					<View style={{ marginHorizontal: 12, width: "48%" }}>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>ID DA CARGA: {carga.id}</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>NOME: {carga.nome || "N/A"}</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								TIPO DE TRANSPORTE: {carga.tipo_transporte || "N/A"}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								TIPO DE CARGA: {carga.tipo_carga || "N/A"}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								REGIÃO DE ENTREGA: {carga.regiao_entrega || "N/A"}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>CAMINHÃO: {carga.caminhao || "N/A"}</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>ROTA: {carga.rota || "N/A"}</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>CARTÃO: {carga.cartao || "N/A"}</Text>
						</View>
					</View>
					<View style={{ marginHorizontal: 12, width: "48%" }}>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA DE EMISSÃO: {formatDate(carga.emissao)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA DE SAÍDA: {formatDate(carga.data_saida)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA DE CHEGADA: {formatDate(carga.data_chegada)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA INÍCIO ENTREGA: {formatDate(carga.data_inicio_entrega)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA SEPARAÇÃO: {formatDate(carga.data_separacao)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								DATA CARREGAMENTO: {formatDate(carga.data_carregamento)}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								APROVAÇÃO GESTOR: {carga.aprovacao_gestor || "N/A"}
							</Text>
						</View>
						<View style={styles.infoBadge}>
							<Text style={{ fontSize: 8 }}>
								OBSERVAÇÃO: {carga.observacao || "Sem observações"}
							</Text>
						</View>
					</View>
				</View>

				{/* Totalizadores */}
			<Text style={styles.sectionTitle} >📦 TOTALIZADORES DA CARGA</Text>
			{/* Primeira linha de 4 cards */}
			<View style={styles.cardContainer}>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Metros Quadrados</Text>
					<Text style={styles.cardValue}>
						{formatNumber(carga.metros_quadrados)} m²
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Peso Total</Text>
					<Text style={styles.cardValue}>
						{formatNumber(carga.peso_total)} kg
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Volume Total</Text>
					<Text style={styles.cardValue}>
						{Number(carga.volume_total || 0).toFixed(3)} m³
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Qtde Pedidos</Text>
					<Text style={styles.cardValue}>{carga.qtde_pedidos || 0}</Text>
				</View>
			</View>
			{/* Segunda linha de 2 cards */}
			<View style={styles.cardContainer}>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Qtde Produtos</Text>
					<Text style={styles.cardValue}>{carga.qtde_produtos || 0}</Text>
				</View>
				<View style={styles.card}>
                    <Text style={styles.cardLabel}>Qtde Embalagens</Text>
                    <Text style={styles.cardValue}>{carga.embalagens || 0}</Text>
                </View>
            </View>

				{/* Valores Financeiros */}
			<Text style={styles.sectionTitle}>💰 VALORES FINANCEIROS</Text>
			<View style={styles.cardContainer} wrap={false}>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Valor Pedágio</Text>
					<Text style={styles.cardValue}>
						{valorMoeda(carga.valor_pedagio || 0)}
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Valor Refeição</Text>
					<Text style={styles.cardValue}>
						{valorMoeda(carga.valor_refeicao || 0)}
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Valor Cartão</Text>
					<Text style={styles.cardValue}>
						{valorMoeda(carga.valor_cartao || 0)}
					</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Valor Dinheiro</Text>
                    <Text style={styles.cardValue}>
                        {valorMoeda(carga.valor_dinheiro || 0)}
                    </Text>
				</View>
            </View>

				{/* Lista de Pedidos */}
				<Text style={styles.sectionTitle} break>
					📝 LISTA DE PEDIDOS ({pedidos.length})
				</Text>

				<View style={styles.cardContainer}>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Qtde NF</Text>
					<Text style={styles.cardValue}>{pedidos.length}</Text>
				</View>
				<View style={styles.card}>
					<Text style={styles.cardLabel}>Valor Total</Text>
					<Text style={styles.cardValue}>{valorMoeda(valorTotalPedidos)}</Text>
				</View>
				<View style={styles.card}>
					    <Text style={styles.cardLabel}>Peso Total</Text>
						<Text style={styles.cardValue}>
							{formatNumber(pesoTotalPedidos)} kg
						</Text>
					</View>
				</View>

				{pedidos.length > 0 ? (
					<>
						<View style={styles.thead}>
							<Text style={{ ...styles.td, width: 35 }}>#</Text>
							<Text style={{ ...styles.td, width: 60 }}>Pedido</Text>
							<Text style={{ ...styles.td, width: 60 }}>Romaneio</Text>
							<Text style={{ ...styles.td, width: 160 }}>Cliente</Text>
							<Text style={{ ...styles.td, width: 80 }}>Cidade</Text>
							<Text style={{ ...styles.td, width: 60 }}>Valor</Text>
							<Text style={{ ...styles.td, width: 60, borderRight: 0 }}>
								Peso
							</Text>
						</View>
						{pedidos.map((pedido, index) => {
							return (
								<View
									key={index}
									style={[
										styles.tableRow,
										index % 2 === 0 ? {} : styles.tableRowAlt,
									]}
								>
									<Text style={{ ...styles.td, width: 35 }}>{index + 1}</Text>
									<Text style={{ ...styles.td, width: 60 }}>
										{pedido.numero_pedido || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 60 }}>
										{pedido.romaneio || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 160 }}>
										{pedido.nome_razao || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 80 }}>
										{pedido.cidade || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 60 }}>
										{valorMoeda(pedido.valor_total || 0)}
									</Text>
									<Text style={{ ...styles.td, width: 60, borderRight: 0 }}>
										{formatNumber(pedido.peso_nf || 0)} kg
									</Text>
								</View>
							);
						})}
					</>
				) : (
					<Text style={{ marginHorizontal: 12, fontSize: 10, fontStyle: "italic" }}>
						Nenhum pedido encontrado.
					</Text>
				)}

				{/* Lista de Produtos */}
				<Text style={styles.sectionTitle} break>
					📦 LISTA DE PRODUTOS ({produtos.length})
				</Text>

				{produtos.length > 0 ? (
					<>
						<View style={styles.thead}>
							<Text style={{ ...styles.td, width: 25 }}>#</Text>
							<Text style={{ ...styles.td, width: 55 }}>Pedido</Text>
							<Text style={{ ...styles.td, width: 55 }}>Código</Text>
							<Text style={{ ...styles.td, width: 180 }}>Descrição</Text>
							<Text style={{ ...styles.td, width: 40 }}>Qtde</Text>
							<Text style={{ ...styles.td, width: 40 }}>Unid</Text>
							<Text style={{ ...styles.td, width: 55 }}>Peso</Text>
							<Text style={{ ...styles.td, width: 65, borderRight: 0 }}>
								Comp.
							</Text>
						</View>
						{produtos.map((produto, index) => {
							return (
								<View
									key={index}
									style={[
										styles.tableRow,
										index % 2 === 0 ? {} : styles.tableRowAlt,
									]}
								>
									<Text style={{ ...styles.td, width: 25 }}>{index + 1}</Text>
									<Text style={{ ...styles.td, width: 55 }}>
										{produto.numero_pedido || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 55 }}>
										{produto.codigo || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 180 }}>
										{produto.descricao || "N/A"}
									</Text>
									<Text style={{ ...styles.td, width: 40 }}>
										{produto.qtde || 0}
									</Text>
									<Text style={{ ...styles.td, width: 40 }}>
										{produto.abreviatura || "UN"}
									</Text>
									<Text style={{ ...styles.td, width: 55 }}>
										{formatNumber(produto.peso || 0)} kg
									</Text>
									<Text style={{ ...styles.td, width: 65, borderRight: 0 }}>
										{produto.comprimento
											? `${Number(produto.comprimento).toFixed(2)} m`
											: "N/A"}
									</Text>
								</View>
							);
						})}
					</>
				) : (
					<Text style={{ marginHorizontal: 12, fontSize: 10, fontStyle: "italic" }}>
						Nenhum produto encontrado.
					</Text>
				)}

				{/* Footer */}
				<View style={styles.footerFixed} fixed>
					<Text style={{ fontSize: 8 }}>
						Relatório gerado em: {new Date().toLocaleString("pt-BR")}
					</Text>
					<Text
						style={{ fontSize: 8 }}
						render={({ pageNumber, totalPages }) =>
							`Página ${pageNumber} de ${totalPages}`
						}
					/>
				</View>
			</Page>
		</Document>
	);
}
